import { Dispatch } from "redux";
import { message } from "antd";
import { contractService } from "../../../../configs/constants";
import axios from "../../../../utils/axiosInceptor";
import * as action_types from "./constants";

type GetBookingFormsParams = {
  limit?: number;
  page?: number;
  value?: string;
  field?: string;
  bookingStatus?: string | null;
  cancelleBookingInclude?: "yes" | "no";
  usagesType?: string;
  propertyId?: string | number;
  unitId?: string | number;
  exportData?: boolean;
  setExportData?: (loading: boolean) => void;
  totalCount?: number;
  bookingColumns?: any[];
  setIsLoading?: (loading: boolean) => void;
};
export const getBookingForms =
  ({
    limit,
    page = 1,
    value = "",
    field,
    bookingStatus = null,
    cancelleBookingInclude = "yes",
    usagesType,
    propertyId,
    unitId,
    exportData = false,
    setExportData,
    totalCount,
    bookingColumns = [],
    setIsLoading,
  }: GetBookingFormsParams) =>
  async (dispatch: Dispatch) => {
    try {
      const params = new URLSearchParams();

      if (limit) params.append("limit", String(limit));
      if (page) params.append("page", String(page));

      if (field && value) {
        params.append("searchby", field);
        params.append("text", value);
      }

      if (bookingStatus) {
        params.append("bookingStatus", bookingStatus);
      }

      if (cancelleBookingInclude) {
        params.append("bookingCancelStatus", cancelleBookingInclude);
      }

      if (usagesType && usagesType !== "") {
        params.append("usagesType", usagesType);
      }

      // ✅ NEW FILTERS
      if (propertyId) {
        params.append("propertyId", String(propertyId));
      }

      if (unitId) {
        params.append("unitId", String(unitId));
      }

      const baseUrl = `${contractService}/booking?${params.toString()}`;
      let url = baseUrl;

      if (exportData) {
        const checkedColumns = bookingColumns
          ?.filter((col) => col.checked && col.headerName !== "Actions")
          .map((col) => col.headerName)
          .join(", ");

        url += `&exportData=true&columns=${checkedColumns}&totalCount=${totalCount || 0}`;
      }

      const {
        data: { result },
      } = await axios.get(url);

      if (result) {
        dispatch({
          type: action_types.GET_BOOKINGFORMS,
          data: result,
        });

        if (exportData) {
          message.success("Export in progress. You will receive the exported file in your email in few minutes");
          setExportData?.(false);
        }
      }
    } catch (error: any) {
      console.error("getBookingForms error:", error);
    } finally {
      setIsLoading?.(false);
    }
  };

export const getBookingPendingReq = (approvaFor) => async (dispatch) => {
  const url = `${contractService}/booking?${approvaFor}`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_BOOKING_REQUESTS,
      data: result,
    });
  }
};

export const getLeasePendingReq = () => async (dispatch) => {
  const url = `${contractService}/booking?leaseManagerApproval=enable`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_LEASE_REQUESTS,
      data: result,
    });
  }
};

export const getPlanPendingReq = () => async (dispatch) => {
  const url = `${contractService}/booking?paymentPlanApproval=enable`;
  const {
    data: { result },
  } = await axios.get(url);

  if (result) {
    dispatch({
      type: action_types.GET_PLAN_REQUESTS,
      data: result,
    });
  }
};

export const sendTenantInvite = async (data) => {
  try {
    const url = `${contractService}/user/sendInvite`;
    const { status } = await axios.post(url, data);

    return status;
  } catch (error) {}
};

export const updateBookingStatus = async (leaseId, payload) => {
  try {
    const url = `${contractService}/booking/${leaseId}`;
    const { status } = await axios.patch(url, payload);

    return status;
  } catch (error) {}
};

export const CreateEjariContract = async (leaseId) => {
  const url = `${contractService}/ejari/createEjariContract`;
  const payload = { leaseId: leaseId };
  const { data } = await axios.post(url, payload);
  return data;
};

export const DownloadEjariContract = async (leaseId) => {
  const url = `${contractService}/ejari/downloadEjariContract`;
  const payload = { leaseId: leaseId };
  const { data } = await axios.post(url, payload);
  return data;
};

export const UploadSignedEjariContract = async (payload) => {
  const url = `${contractService}/ejari/uploadSignedFile`;
  const status = await axios.post(url, payload, { headers: { "Content-Type": "multipart/form-data" } });
  return status;
};

export const UploadEjariCertificate = async (payload) => {
  const url = `${contractService}/ejari/uploadEjariFile`;
  const status = await axios.post(url, payload, { headers: { "Content-Type": "multipart/form-data" } });
  return status;
};

export const ActivateEjari = async (leaseId) => {
  const url = `${contractService}/booking/${leaseId}`;
  const payload = { status: "leaseActive" };
  const { data } = await axios.patch(url, payload);
  return data;
};

export const PrintEjariCertificateContract = async (leaseId) => {
  const url = `${contractService}/ejari/printEjariCertificateContract`;
  const payload = { leaseId: leaseId };
  const { data } = await axios.post(url, payload);
  return data;
};
